import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentCourseErrorRateGauge from './ContentCourseErrorRateGauge';
import { ContentCourseErrorRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentCourseErrorRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentCourseErrorRateListService.load();
  }
  render() {
    const data = ContentCourseErrorRateListService.getChart();
    return (
      <ContentCourseErrorRateGauge
        loading={
          ContentCourseErrorRateListService.fetchCurrent.fetching ||
          ContentCourseErrorRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentCourseErrorRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('UNIT_EXECUTION_ERROR_RATE')}
      />
    );
  }
}

export default observer(ContentCourseErrorRateGaugeContainer);
